import { QuestionBase, QuestionBaseParams, QuestionUITypes } from './question-base';

export class IntegerboxQuestion extends QuestionBase<number> {
  public questionType: QuestionUITypes = QuestionUITypes.INTEGER;

  constructor(questionParams: QuestionBaseParams<number>) {
    super(questionParams);
  }

  public getValueForRequest() : number{
    return parseInt( this.getAvailableValue() );
  }
}


// WEBPACK FOOTER //
// ./src/app/question-integerbox.ts